import {downloadURL, downloadURLBrRecordId} from "../common/AttachmentLinkUtil";
import * as DownloadPurpose from "../constants/DownloadPurpose";
import {isNotEmptyOrNull} from "../common/NamaCommon";
import {removeCurrentPopup} from "./list/ListViewColumns";

export class PreviewPopupView {
    constructor(attachmentId, recordId, entityType, owner, fileName) {
        let that = this;
        that.realImg = $(`<img>`);
        that.file = $(`<embed>`);
        that.content = $(`<div id =${attachmentId} class="previewPopUp"></div>`);
        that.attachmentId = attachmentId;
        that.recordId = recordId;
        that.entityType = entityType;
        that.owner = owner;
        that.fileName = fileName;
        that.attachFile(fileName);
    }

    attachFile() {
        let that = this;
        if (that.fileName && that.fileName.trim().toLowerCase().endsWith(".pdf"))
            that.attachPdfFileToPopup();
        else
            that.attachImageToPopup();
    }

    attachImageToPopup() {
        let that = this;
        that.content.append(that.realImg);
        that.realImg.on('load', function () {
            let maxWidth = $(window).width();
            let maxHeight = $(window).height();
            let ratio = 0;
            let width = that.realImg.width;
            let height = that.realImg.height;
            if (width > maxWidth) {
                ratio = maxWidth / width; // get ratio for scaling image
                height = height * ratio; // Reset height to match scaled
                width = width * ratio; // Reset width to match scaled
            }

            // Check if current height is larger than max
            if (height > maxHeight) {
                ratio = maxHeight / height; // get ratio for scaling image
                height = height * ratio; // Reset height to match scaled
                width = width * ratio; // Reset width to match scaled image
            }
            that.content.kendoPopup({
                anchor: that.owner,
                adjustSize: {
                    width: width,
                    height: height
                },
                position: "top right",
                close: function (e) {
                    that.off();
                },
                activate(e) {
                    that.content.closest(".k-animation-container").css({top: '10px'});
                }
            });
            that.realImg.show();
        });
        that.realImg.attr("src", that.previewUrl(that.attachmentId, that.recordId, that.entityType));
        that.realImg.hide();
    }

    previewUrl(attachmentId, recordId, entityType) {
        if (isNotEmptyOrNull(attachmentId))
            return downloadURL(attachmentId, entityType, DownloadPurpose.THUMBNAIL);
        else
            return downloadURLBrRecordId(recordId, entityType, DownloadPurpose.THUMBNAIL, false);
    }

    previewByRecordId() {
        let that = this;
        if (!that.recordId || !that.content)
            return;
        that.attachmentId = "";
        that.preview();
    }

    popUp() {
        let that = this;
        if (!that.content)
            return null;
        return that.content.data("kendoPopup");
    }

    preview() {
        let that = this;
        if (!that.content.data("kendoPopup")) {
            setTimeout(() => that.preview(), 250);
            return;
        }
        that.content.data("kendoPopup").open();
    }

    off() {
        let that = this;
        if (!that.content || !that.content.data("kendoPopup"))
            return;
        that.content.data("kendoPopup").destroy();
        removeCurrentPopup();
    }

    attachPdfFileToPopup() {
        let that = this;
        that.content.append(that.file);
        that.file.attr("src", that.previewUrl(that.attachmentId, that.recordId, that.entityType));
        let maxWidth = $(window).width();
        let maxHeight = $(window).height();
        that.file.width(maxWidth / 1.1);
        that.file.height(maxHeight / 1.1);
        that.content.kendoPopup({
            anchor: $("#navbar"),
            origin: "bottom right",
            position: "top right",
            collision: "flip fit",
            close: function (e) {
                that.off();
            }
        });
    }
}